import dayjs from 'dayjs'
import { DateFormat } from 'constants/General'
import { Profile } from 'types/types'
import { LegalAgreementType } from './types'

export const getAgreementDisplayDate = (agreementDate: string) => {
  return dayjs(agreementDate).format(DateFormat.DD_MMM_YYYY_HH_MM_A)
}

export const getIsAgreementAssignedToUser = (agreement: LegalAgreementType, profile: Profile) => {
  const agreementEmail = agreement?.user?.emailAddress
  if (!agreementEmail) return true
  return agreementEmail === profile?.emailAddress
}
